module.exports = __webpack_public_path__ + "img/p3.08410d2a.jpg";